<template>
  <div>
    <img
      :src="source"
      alt="Logo da GreeZon"
      :height="height"
      id="greezon_logo"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    source(): string {
      const types: { [key: string]: string } = {
        primary: require("@/presentation/assets/img/logo-primary.svg"),
        white: require("@/presentation/assets/img/logo.svg"),
        square: require("@/presentation/assets/img/logo-square.svg"),
      };
      return types[this.type];
    },
  },
  props: {
    height: {
      default: "50",
      type: String,
    },
    type: {
      type: String,
      default: "primary",
    },
  },
  methods: {
    onGoHome() {
      this.$router.push("/");
    },
  },
});
</script>
